export default "__VITE_ASSET__B1H7U0TG__"